<template>
	<v-dialog persistent width="auto" v-model="dialog" v-if="item">
		<v-card style="height: 639px; width: 1100px" class="overflow-auto d-flex flex-column">
			<v-card-title class="card-header text-left fixed-card-title2">
				<v-row no-gutters>
					<v-col class="align-center d-flex" cols="10">
						<v-toolbar-title v-if="$i18n.locale === 'en'">
							{{ item.patientName }} Billing Details - {{ getMonthName(item.billingMonth) }} {{ item.billingYear }}
						</v-toolbar-title>
						<v-toolbar-title v-else>
							Datos de facturación de {{ item.patientName }} - {{ getMonthName(item.billingMonth) }}
							{{ item.billingYear }}
						</v-toolbar-title>
					</v-col>
					<v-spacer />
					<v-icon @click="$emit('previousPerson')" :disabled="loading" class="white-icon mr-2">mdi-chevron-left</v-icon>
					<v-icon @click="$emit('nextPerson')" :disabled="loading" class="white-icon mr-2">mdi-chevron-right</v-icon>
					<v-icon @click="$emit('closeDialog')" class="white-icon">mdi-close</v-icon>
				</v-row>
			</v-card-title>
			<v-card-text class="pa-4 flex-grow-1 d-flex flex-column">
				<v-row dense class="font-size12">
					<v-col cols="4">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99453
								<v-icon v-if="details?.cptCode99453?.status" color="green" size="16" class="ml-1">
									mdi-check-circle
								</v-icon>
							</span>
							<div class="elevation-0" v-if="details?.cptCode99453">
								<div dense class="d-flex justify-space-between">
									<span>{{ $t('device') }}</span>
									<span class="font-weight-bold">{{ details.cptCode99453.deviceTypeTitle }}</span>
								</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="4">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99445
								<v-icon v-if="item.cptCode99445?.status" color="green" size="16" class="ml-1">mdi-check-circle</v-icon>
							</span>
							<div class="elevation-0" v-if="item?.cptCode99445">
								<div dense class="d-flex justify-space-between">
									<span> {{ $t('measurements') }}</span>
									<span class="font-weight-bold">
										{{ item.cptCode99445.status ? item.cptCode99445.totalMeasurements : 0 }}
									</span>
								</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="4">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99454
								<v-icon v-if="item.cptCode99454?.status" color="green" size="16" class="ml-1">mdi-check-circle</v-icon>
							</span>
							<div class="elevation-0" v-if="item?.cptCode99454">
								<div dense class="d-flex justify-space-between">
									<span> {{ $t('measurements') }}</span>
									<span class="font-weight-bold">
										{{ item.cptCode99454.totalMeasurements }}
									</span>
								</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="3">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99470
								<v-icon v-if="item.cptCode99470?.status" color="green" size="16" class="ml-1">mdi-check-circle</v-icon>
							</span>
							<div class="elevation-0" v-if="item">
								<div dense class="d-flex justify-space-between">
									<span>{{ $t('time') }}</span>
									<span class="font-weight-bold" v-if="item?.cptCode99470">
										{{ item?.cptCode99470.status ? formatDuration(item?.cptCode99470.totalIntervalInSeconds) : '0sec' }}
									</span>
								</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="3">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99457
								<v-icon v-if="item.cptCode99457?.status" color="green" size="16" class="ml-1">mdi-check-circle</v-icon>
							</span>
							<div class="elevation-0" v-if="item">
								<div dense class="d-flex justify-space-between">
									<span>{{ $t('time') }}</span>
									<span class="font-weight-bold" v-if="item?.cptCode99457">
										{{ item?.cptCode99457.status ? formatDuration(item?.cptCode99457.totalIntervalInSeconds) : '0sec' }}
									</span>
								</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="3">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99458 1st
								<v-icon v-if="item.cptCode99458First?.status" color="green" size="16" class="ml-1">
									mdi-check-circle
								</v-icon>
							</span>
							<div class="elevation-0" v-if="item?.cptCode99458First">
								<div dense class="d-flex justify-space-between">
									<span>{{ $t('time') }}</span>
									<span class="font-weight-bold">
										{{ formatDuration(item.cptCode99458First.totalIntervalInSeconds) }}
									</span>
								</div>
							</div>
						</v-card>
					</v-col>
					<v-col cols="3">
						<v-card width="100%" elevation="3" class="px-4 py-2 fill-height">
							<span class="d-flex justify-start font-weight-bold">
								CPT Code 99458 2nd
								<v-icon v-if="item.cptCode99458Second?.status" color="green" size="16" class="ml-1">
									mdi-check-circle
								</v-icon>
							</span>
							<div class="elevation-0" v-if="item?.cptCode99458Second">
								<div dense class="d-flex justify-space-between">
									<span>{{ $t('time') }}</span>
									<span class="font-weight-bold">
										{{ formatDuration(item.cptCode99458Second.totalIntervalInSeconds) }}
									</span>
								</div>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<v-row dense>
					<v-col cols="6">
						<v-text-field
							class="mb-2"
							v-model="search99454"
							append-icon="mdi-magnify"
							:label="$t('search')"
							dense
							outlined
							hide-details />
						<v-data-table
							:loading="loading"
							:headers="cptCode99454Headers"
							:no-data-text="$t('no-data-available')"
							:loading-text="$t('loading')"
							:search="search99454"
							:items="cptCode99454WithDetails"
							:items-per-page="-1"
							sort-by="measuredIntervalFrom"
							sort-desc
							item-key="id"
							fixed-header
							dense
							class="data-table-outline"
							style="overflow-y: auto"
							width="100%"
							height="300"
							:footer-props="{
								itemsPerPageText: this.$t('row'),
								itemsPerPageAllText: this.$t('all'),
							}">
							<template #item="{ item, index }">
								<tr :class="getRowsForDataTable(index)">
									<td class="text-left font-size12">
										{{ item.measurementDeviceTypeTitle }}
									</td>
									<td class="text-right font-size12">
										{{ formatDate(item.measuredIntervalFrom) }}
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
					<v-col cols="6">
						<v-text-field
							class="mb-2"
							v-model="search99457"
							append-icon="mdi-magnify"
							:label="$t('search')"
							outlined
							dense
							hide-details />
						<v-data-table
							:loading="loading"
							:no-data-text="$t('no-data-available')"
							:loading-text="$t('loading')"
							:headers="cptCode99457Headers"
							:search="search99457"
							:items="cptCode99457WithDetails"
							:items-per-page="-1"
							:item-key="'refAppointmentId'"
							sort-by="eventStartedAt"
							sort-desc
							dense
							fixed-header
							class="data-table-outline"
							style="overflow-y: auto"
							width="100%"
							height="300"
							:footer-props="{
								itemsPerPageText: this.$t('row'),
								itemsPerPageAllText: this.$t('all'),
							}">
							<template #item="{ item, index }">
								<tr :class="getRowsForDataTable(index)">
									<td class="text-left font-size12">
										{{ item.billingItemType }}
									</td>
									<td class="text-left font-size12">
										{{ formatDate(item.eventStartedAt) }}
									</td>
									<td class="text-left font-size12">
										<span v-if="item.billingItemType !== 'MEDICAL_NOTE'">
											{{ formatDate(item.eventEndedAt) }}
										</span>
									</td>
									<td class="text-left font-size12">
										{{ calculateDuration(item.eventStartedAt, item.eventEndedAt, item) }}
									</td>
								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>
<script>
import { mapState } from 'vuex';
import { formatDuration, getMonthName, getRowsForDataTable } from '../../../utils/utilities';

export default {
	props: ['dialog', 'item'],
	data () {
		return {
			itemsType: [],
			search99457: null,
			search99454: null,
			loadingTimeTracking: false,
			loading: true,
		};
	},
	computed: {
		...mapState({
			bilingItemType: (state) => state.billings.billingDetailsForPatientForMonth,
			details: (state) => state.billings.billingDetailsForPatientForMonth?.billingHeaderDetailsData,
			userDetails: (state) => state.authentication.userData,
		}),
		cptCode99454WithDetails () {
			return this.details?.cptCode99454WithDetails?.details;
		},
		cptCode99457WithDetails () {
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.loadingTimeTracking = true;
			const data = [];
			var dataItem = {};
			if (this.details?.cptCode99457WithDetails) {
				this.details.cptCode99457WithDetails.details9945799458.forEach((element) => {
					var itemType = this.itemsType[element.billingItemType - 1];
					dataItem = {
						billingItemType: itemType,
						measurementDeviceTypeTitle: element.measurementDeviceTypeTitle,
						measuredIntervalFrom: element.measuredIntervalFrom,
						eventStartedAt: element.eventStartedAt,
						eventEndedAt: element.eventEndedAt,
						intervalInSeconds: element.intervalInSeconds,
					};
					data.push(dataItem);
				});
			}
			// eslint-disable-next-line vue/no-side-effects-in-computed-properties
			this.loadingTimeTracking = false;
			return data;
		},
		cptCode99454Headers () {
			return [
				{ text: this.$t('device'), value: 'measurementDeviceTypeTitle', class: 'secondary' },
				{ text: this.$t('time'), value: 'measuredIntervalFrom', class: 'secondary', align: 'end' },
			];
		},
		cptCode99457Headers () {
			return [
				{ text: this.$t('interaction-type'), value: 'billingItemType', class: 'secondary' },
				{ text: this.$t('started'), value: 'eventStartedAt', class: 'secondary' },
				{ text: this.$t('ended'), value: 'eventEndedAt', class: 'secondary' },
				{ text: this.$t('duration'), value: 'duration', class: 'secondary' },
			];
		},
	},
	watch: {
		item: {
			immediate: true,
			deep: true,
			async handler (value) {
				await this.initialize({ patientId: value.patientId, month: value.billingMonth, year: value.billingYear });
				this.getType();
			},
		},
	},
	methods: {
		formatDuration,
		getRowsForDataTable,
		getMonthName,
		calculateDuration (startTime, endTime, item) {
			if (item.billingItemType === 'MEDICAL_NOTE') {
				const minutes = Math.floor(item.intervalInSeconds / 60);
				const seconds = item.intervalInSeconds % 60;
				return `${minutes}m ${seconds}s`;
			}
			const start = new Date(startTime);
			const end = new Date(endTime);
			const durationInMilliseconds = end - start;
			const minutes = Math.floor((durationInMilliseconds % 3600000) / 60000);
			const seconds = Math.floor((durationInMilliseconds % 60000) / 1000);
			return `${minutes}m ${seconds}s`;
		},
		async initialize (headers) {
			this.loading = true;
			await this.$store.dispatch('billings/getbillingdetailsforpatientformonth', headers).then((res) => {});
			this.loading = false;
		},
		getType () {
			if (this.bilingItemType?.billingItemTypes) {
				const count = Object.keys(this.bilingItemType?.billingItemTypes).length;
				for (let i = 1; i <= count; i++) {
					this.itemsType.push(this.bilingItemType?.billingItemTypes?.[i]);
				}
			}
		},
		formatDate (val) {
			const dateObject = new Date(val);
			return dateObject.toLocaleString('en-US', {
				month: 'short',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				hour12: true,
			});
		},
	},
};
</script>
